import { Component, Input } from '@angular/core';
import { StatesService } from 'src/app/services/states.service';

@Component({
  selector: 'app-blank-component',
  templateUrl: './blank-component.component.html',
  styleUrls: ['./blank-component.component.scss']
})
export class BlankComponentComponent {
  @Input() component: any;

  constructor(
    public statesService: StatesService
  ) {}
  ngOnInit(): void {}

  onMouseDown() {
    this.statesService.onMouseDown(this.component);
  }
  onMouseUp() {
    this.statesService.onMouseUp(this.component);
  }

  onMouseEnter() {
    this.statesService.onMouseEnter(this.component);
  }
  onMouseLeave() {
    this.statesService.onMouseLeave(this.component);
  }
}
